import { alpha, createGenerateClassName, makeStyles } from "@material-ui/core/styles";
export var generateClassName = createGenerateClassName({
    disableGlobal: true,
    productionPrefix: "RemarModal",
    seed: "ReMarSimpleModalComponent"
});
export var useSimpleModalStyles = makeStyles(function (theme) { return ({
    modal: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "250px",
        margin: "auto"
    },
    deleteIcon: {
        background: "transparent"
    },
    card: {
        borderRadius: "5px"
    },
    title: {
        fontfamily: "Poppins",
        lineHeight: " 1.33",
        color: alpha(theme.palette.text.primary, 0.87),
        fontSize: "18px",
        fontWeight: 900
    },
    closeIcon: {
        marginTop: "-15px",
        marginRight: "-15px",
        flex: "0 1"
    },
    subTitle: {
        color: alpha(theme.palette.text.primary, 0.6),
        marginBottom: "25px",
        textAlign: "center",
        "&>span": {
            color: "white",
            fontWeight: 500
        }
    },
    subTitleContainer: {
        margin: "auto",
        width: "80%"
    },
    modalHeader: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: "40px",
        justifyContent: "space-between"
    },
    modalFooter: {
        paddingTop: "25px",
        borderTop: "1px solid ".concat(alpha(theme.palette.text.primary, 0.1)),
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    }
}); }, { name: "SimpleModal" });
//# sourceMappingURL=styles.js.map